import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../Atoms";
import { COLOR_BUTTON } from "../../Config/Config";
import PropTypes from "prop-types";

const RetryButtons = ({ pathToPaiement }) => {
  return (
    <div className="mt-30 text-center">
      <div className="text-center mt-20">
        <Link to={pathToPaiement}>
          <Button
            text="Essayer à nouveau"
            className="button-red-rounded"
            color={COLOR_BUTTON.SECOND_RED}
          />
        </Link>
      </div>
      <div className="text-center mt-20">
        <Link to="/">
          <Button
            text="Retour à l'accueil de CGRM"
            className="button-big-round"
            isAlreadyOutline={true}
            color={COLOR_BUTTON.BLACK}
          />
        </Link>
      </div>
    </div>
  );
};

RetryButtons.propTypes = {
  pathToPaiement: PropTypes.string.isRequired,
};

export default RetryButtons;
